var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.578,
    height: 25.578,
    viewBox: "0 0 25.578 25.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-103 -283.422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.789,
    cy: 12.789,
    r: 12.789,
    transform: "translate(103 283.422)",
    fill: "#4a4a4a",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106 287.184)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.814C.233,1.106,1.625,0,4.672,0h.1C8.132,0,9.479,1.347,9.479,4.709v4.9c0,3.363-1.347,4.709-4.709,4.709h-.1c-3.024,0-4.416-1.091-4.664-3.754",
    transform: "translate(6.695 1.873)",
    fill: "none",
    stroke: "#e41965",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.561,0H0",
    transform: "translate(2.723 9.028)",
    fill: "none",
    stroke: "#e41965",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52,0,0,2.52,2.52,5.04",
    transform: "translate(1.881 6.507)",
    fill: "none",
    stroke: "#e41965",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H18.055V18.055H0Z",
    transform: "translate(18.055 18.055) rotate(180)",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exitIcon.5e6734daea91d51258c856ccdbeb5c98.svg";
export { ForwardRef as ReactComponent };